import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
 import { makeStyles } from '@material-ui/styles';
 import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import {
  Button,
  Card,
  Avatar,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Switch,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop : theme.spacing(2),
  },
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1150
  },
  actions: {
    padding: theme.spacing(0, 1),
    justifyContent: 'flex-end'
  }
}));

const Answers = props => {
  const { className, surveyanswers,orders,onPageChange,onPageLimit,languages, ...rest } = props;

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showpreview, setShowpreview] = useState(false);
  const [previewurl, setpreviewurl] = useState('');

  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };

  const handleChangePage = (event, page) => {
    setPage(page);
    onPageChange(page)
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value);
    onPageLimit(event.target.value)
  };
  function previewimage(url)
  {
    setpreviewurl(url)
    setShowpreview(true)
  }
  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600]
  };


  return (
    <>
    {showpreview && (
          <Lightbox
            mainSrc={previewurl}
           // nextSrc={images[(photoIndex + 1) % images.length]}
           // prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setShowpreview(false)}
            onMovePrevRequest={() =>
              alert('prev')
            }
            onMoveNextRequest={() =>
              alert('next')
            }
          />
        )}
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        <CardHeader
          
          title="Answers"
          action={
            <Button
            color="primary"
            type="submit"
            variant="outlined"
            onClick={()=>
              props.onAddanswer(-1)
            }
          >
            Add Answer
          </Button>
        }
        />
        <Divider />
        <CardContent className={classes.content}>
            <div className={classes.inner}>
            {languages.length > 0 &&    <Table>
                <TableHead>
                  <TableRow>
                  

                    <TableCell>S no</TableCell>
                    {languages.map((order,index) => (
                       <TableCell>{order.name}</TableCell>
                    ))}
                    <TableCell align="center">Is Answer</TableCell>
                    <TableCell align="center">Is Comment</TableCell>
                    <TableCell align="center">Edit</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {surveyanswers.map((order,index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                      {/* <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedOrders.indexOf(order.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, order.id)}
                          value={selectedOrders.indexOf(order.id) !== -1}
                        />
                      </TableCell> */}
                      <TableCell>
                      {(page * rowsPerPage)+(index+1)}
                        
                      </TableCell>
                      {languages.map((lang) => (
                      
                      <TableCell>{order[`answer${lang.name}`]}</TableCell>
                    
                      ))}

                  <TableCell padding="checkbox">
                              <Switch
                            checked={order.is_answer}
                            color="secondary"
                            edge="start"
                            name="canHire"
                          />
                      </TableCell>
                      
                      <TableCell padding="checkbox">
                      <Switch
                            checked={order.is_comment}
                            color="secondary"
                            edge="start"
                            name="canHire"
                          />
                      </TableCell>
                      {/* <TableCell>
                         <Label
                          color={paymentStatusColors[order.is_active ? 'active' : 'inactive']}
                          variant="contained"
                        >
                          {order.is_active ? 'Active' : 'In Active'}
                        </Label>

                      </TableCell> */}
                      {/* <TableCell>
                      <Typography variant="body1">
                          {moment(order.createdat).format(
                            'DD MMM YYYY | hh:mm a'
                          )}
                        </Typography>
                      </TableCell> */}
                     
                      <TableCell align="center">
                        <Button
                          color="primary"
                          onClick={()=>
                            props.onAddanswer(index)
                          }
                          size="small"
                         // to={'/management/orders/1'}
                          variant="outlined"
                        >
                          Edit
                        </Button>
                      </TableCell>
                      {/* <TableCell align="center">
                        <Button
                          color="primary"
                          component={RouterLink}
                          size="small"
                          to={'/management/orders/1'}
                          variant="outlined"
                        >
                         View
                        </Button>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>}
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={surveyanswers.length}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
    </>
  );
};

Answers.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  onPageChange: PropTypes.func,
  onPageLimit : PropTypes.func
};

Answers.defaultProps = {
  orders: []
};

export default Answers;
